import type { FeedItem } from "../../../../types/content/feedItem";

import styles from "./LatestNewsBoxCluster.module.scss";
import { TeaserCluster } from "../../../TeaserCluster/TeaserCluster";
import { FeedItemToTeaser } from "../../utils/feedItemToTeaser";

const LatestNewsBoxCluster = ({
  boxGroup,
  positionInFeed,
  teaserWeight,
}: {
  boxGroup: FeedItem;
  positionInFeed: number;
  teaserWeight: number | null;
}) => {
  return (
    <div className={styles.latestNewsBoxContainer}>
      <TeaserCluster
        footer={boxGroup.footer}
        header={boxGroup.header}
        style={boxGroup.style}
        hasCardStyling={false}
        hasFooterBorder={false}
        isBox
        teaserWeightValue={teaserWeight}
      >
        <FeedItemToTeaser feedItem={boxGroup} positionInFeed={positionInFeed} />
      </TeaserCluster>
    </div>
  );
};

export { LatestNewsBoxCluster };
